module.exports = __webpack_public_path__ + "img/badge-recommendations-silver-darkbg.f1d90722.svg";